import { ReactElement } from 'react'

import { ExportMenu } from '../../../../elements/ExportMenu'
import { useDownloadCreditorBalanceStatementExport } from '../../../../hooks/useDownloadCreditorBalanceStatementExport'

export const StatementExportMenu = (): ReactElement => {
  const { downloadExport, isExporting } = useDownloadCreditorBalanceStatementExport()

  return <ExportMenu isExporting={isExporting} onSelectFormat={downloadExport} />
}
